<template>
  <div class="c-panel">
    <ol
      v-for="rankingItem in rankingItems"
      :key="rankingItem.id"
      class="p-content-plan-manual-ranking-texts"
    >
      <ListItemContentManualText
        v-for="item in rankingItem.contents"
        :key="item.id"
        :item="item"
      />
    </ol>
  </div>
</template>

<script>
import ListItemContentManualText from '@/components/contentPlans/ListItemContentManualText';
export default {
  props: {
    tdhWordsItems: {
      type: Array,
      required: true
    },
    scope: {
      type: String, //'h1'|'h2'|'title'|'description'
      required: true
    }
  },
  components: {
    ListItemContentManualText
  },
  computed: {
    rankingItems() {
      return this.tdhWordsItems.map((item, index) => {
        const contents = [];
        const contentObj = {
          contentType: item.contentType,
          rank: item.rank,
          url: item.url,
          isOwnSite: item.isOwnSite
        };

        // データがある時
        if (
          item[this.scope] &&
          item[this.scope].contents &&
          item[this.scope].contents.length
        ) {
          item[this.scope].contents.forEach((content, contentIndex) => {
            contents.push({
              ...contentObj,
              id: `${index}_${contentIndex}`,
              content
            });
          });
        } else {
          // 圏外: rankがnull
          // pdf: contentType === 'pdf'
          // データ取得中: (h1|h2|title|description)がnull
          // データがない: (h1|h2|title|description).wordsがnull
          const isLoading =
            item.rank &&
            item.contentType !== 'pdf' &&
            item[this.scope] === null;

          contents.push({
            ...contentObj,
            id: `${item.rank}_0`,
            content: null,
            isLoading
          });
        }
        return { id: index, contents };
      });
    }
  }
};
</script>
